<template>
    <vBusinessUnitComponent :postList="postList" v-if="flag"></vBusinessUnitComponent>
</template>
<script>
import vBusinessUnitComponent from '../../listComponent/basicdata/performance/businessUnitComponent.vue';
export default {
    name: 'business_unit',
    components: {
        vBusinessUnitComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                config_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>